export default __webpack_public_path__ + "static/media/mg-la-vela.8d296fd8.jpg";